import React from 'react';
import { Link } from 'react-router-dom';
import 'styles/common.css';
import './Technologies.css';

const Technologies = () => {
  const technologies = [
    {
      title: "AI-Driven Molecular Generation and Screening Platform",
      subtitle: "High-Throughput Innovation with High-Confidence Filtering",
      features: [
        "Transformer-based molecular language modeling",
        "Diffusion model–based progressive generation",
        "VAE + Reinforcement Learning multi-objective optimization",
        "Rapid generation of highly diverse molecular structures",
        "Precise control of physicochemical and pharmacokinetic properties",
        "Molecular reproduction rate exceeding 60% in validation benchmarks"
      ],
      comparison: "Outperforms leading international platforms including Exscientia, Insilico Medicine, and XtalPi"
    },
    {
      title: "AI + Quantum Simulation Optimization Platform",
      subtitle: "From Molecular Generation to Precise Structural Control",
      features: [
        "Integration of AI algorithms with multi-scale physical simulation",
        "Molecular Dynamics (MD) and Free Energy Perturbation (FEP) simulations",
        "Proprietary AI-assisted Quantum Optimization Module",
        "Atomic-level structural correction based on electronic density",
        "Refining ligand conformations at complex protein-binding interfaces",
        "Published in leading physical chemistry journal (DOI: 10.1021/acs.jpclett.0c02654)"
      ]
    },
    {
      title: "Automated AI–Experiment Closed-Loop Optimization Platform",
      subtitle: "Building an Intelligent Feedback-Driven Drug Discovery Engine",
      features: [
        "Fully automated AI–Experiment Closed-Loop System",
        "High-efficiency iterative cycle: prediction → validation → feedback → fine-tuning",
        "Dynamic incorporation of experimental data into training pipeline",
        "Proprietary text–data engine based on large language models",
        "Processes structured and unstructured data from multiple sources",
        "Superior algorithmic generality and predictive stability"
      ],
      comparison: "Outperforms competitors such as IQVIA and Tempus Labs"
    },
    {
      title: "LLM-Enhanced Molecular Generation and Knowledge Reasoning",
      subtitle: "Intelligent User Interaction and Knowledge Integration Platform",
      features: [
        "Integration of cutting-edge chemical and protein language models",
        "Understanding semantic structure of molecules and biological mechanisms",
        "Identification of multi-target interaction pathways",
        "Natural language interaction with the platform",
        "Real-time optimization goals and visualized feedback",
        "\"What you see is what you design\" drug discovery experience"
      ]
    }
  ];

  return (
    <div className="technologies-page">
      <div className="technologies-container">
        <div className="technologies-header">
          <Link to="/" className="back-button">← Back to Home</Link>
          <h1 className="technologies-title">Core Technological Advantages</h1>
          <p className="technologies-subtitle">Innovative AI and Quantum Computing Solutions</p>
        </div>

        <div className="technologies-content">
          {technologies.map((tech, index) => (
            <section key={index} className="technology-section">
              <h2>{tech.title}</h2>
              <p className="technology-subtitle">{tech.subtitle}</p>
              
              <div className="features-list">
                <h4>Key Features:</h4>
                <ul>
                  {tech.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              {tech.comparison && (
                <div className="comparison-note">
                  <strong>Competitive Advantage:</strong> {tech.comparison}
                </div>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Technologies;